import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Button, Modal as ReactstrapModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getCubicMeter, getWeight } from '../../commons/helpers';

class SimpleLineModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formInputs: {
                e_type_of_packaging: 'Carton',
                e_qty: 0,
                e_dimLength: 0,
                e_dimWidth: 0,
                e_dimHeight: 0,
                e_dimUOM: 'cm',
                e_weightUOM: 'kg',
                e_weightPerEach: 0,
            },
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleModal: PropTypes.func,
        createBookingLine: PropTypes.func,
        updateBookingLine: PropTypes.func,
        deleteBookingLine: PropTypes.func,
        editMode: PropTypes.bool,
        packageTypes: PropTypes.array,
        line: PropTypes.object,
        isYalePrima: PropTypes.bool,
    };

    static defaultProps = {
        isOpen: true,
    };

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.line && newProps.line != this.props.line) {
            let formInputs = {
                e_type_of_packaging: newProps.line.e_type_of_packaging,
                e_item: newProps.line.e_item,
                e_qty: newProps.line.e_qty,
                e_dimLength: newProps.line.e_dimLength,
                e_dimWidth: newProps.line.e_dimWidth,
                e_dimHeight: newProps.line.e_dimHeight,
                e_dimUOM: 'cm',
                e_weightUOM: 'kg',
                e_weightPerEach: newProps.line.e_weightPerEach,
                lineDetails: newProps.line.lineDetails,
            };
            formInputs = this.calcTotals(formInputs);
            this.setState({ formInputs });
        }

        if (this.props.line && !newProps.line) {
            this.resetformInputs();
        }
    }

    notify = (text) => toast(text);

    resetformInputs = () => {
        this.setState({
            formInputs: {
                e_type_of_packaging: 'Carton',
                e_item: ' ',
                e_qty: 0,
                e_dimLength: 0,
                e_dimWidth: 0,
                e_dimHeight: 0,
                e_dimUOM: 'cm',
                e_weightUOM: 'kg',
                e_weightPerEach: 0,
            }
        });
    }

    calcTotals = (formInputs) => {
        formInputs['e_1_Total_dimCubicMeter'] = getCubicMeter(
            formInputs['e_qty'],
            formInputs['e_dimUOM'],
            formInputs['e_dimLength'],
            formInputs['e_dimWidth'],
            formInputs['e_dimHeight']
        );
        formInputs['e_Total_KG_weight'] = getWeight(formInputs['e_qty'], formInputs['e_weightUOM'], formInputs['e_weightPerEach']);
        formInputs['total_2_cubic_mass_factor_calc'] = (Number.parseFloat(formInputs['e_1_Total_dimCubicMeter']).toFixed(5) * 250).toFixed(2);
        return formInputs;
    }

    onInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formInputs = this.state.formInputs;
        formInputs[name] = value;
        formInputs = this.calcTotals(formInputs);
        this.setState({formInputs});
    }

    onSubmit(e) {
        e.preventDefault();
        const { formInputs } = this.state;
        const { editMode } = this.props;

        if (editMode) {
            this.props.updateBookingLine(formInputs);
        } else {
            this.props.createBookingLine(formInputs);
        }

        this.props.toggleModal();
        this.resetformInputs();
    }

    render() {
        const { isOpen, editMode, packageTypes, isYalePrima } = this.props;
        const { formInputs } = this.state;

        const packageTypesOptions = packageTypes.map((packageType, key) => {
            return (<option key={key} value={packageType.dmePackageTypeDesc}>{packageType.dmePackageTypeDesc}</option>);
        });

        return (
            <ReactstrapModal isOpen={isOpen} toggle={() => this.props.toggleModal()} className="simple-line-modal" centered={true}>
                <ModalHeader toggle={() => this.props.toggleModal()}>Line Modal</ModalHeader>
                <ModalBody>
                    <div className="line-form">
                        <form onSubmit={(e) => this.onSubmit(e)} role="form" id="simple-line-form">
                            <label>
                                <p>Packaging</p>
                                <select
                                    name="e_type_of_packaging"
                                    onChange={(e) => this.onInputChange(e)}
                                    value = {formInputs['e_type_of_packaging']}
                                >
                                    {packageTypesOptions}
                                    {packageTypes.filter(packageType => packageType.dmePackageTypeDesc === formInputs['e_type_of_packaging']).length === 0 ? (
                                        <option value={formInputs['e_type_of_packaging']}>{formInputs['e_type_of_packaging']}</option>
                                    ) : null}
                                </select>
                            </label>
                            <label className={isYalePrima ? 'none' : ''}>
                                <p>Item Description</p>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="e_item"
                                    value={formInputs['e_item'] ? formInputs['e_item'] : ''}
                                    onChange={(e) => this.onInputChange(e)}
                                    required={!isYalePrima}
                                />
                            </label>
                            <label>
                                <p>Quantity</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    step="0.01"
                                    min="1"
                                    name="e_qty"
                                    value={!isNaN(formInputs['e_qty']) ? formInputs['e_qty'] : 0}
                                    onChange={(e) => this.onInputChange(e)}
                                    required
                                />
                            </label>
                            <label>
                                <p>Wgt Each (kg)</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    step="0.01"
                                    min="0.01"
                                    name="e_weightPerEach"
                                    value={!isNaN(formInputs['e_weightPerEach']) ? formInputs['e_weightPerEach'] : 0}
                                    onChange={(e) => this.onInputChange(e)}
                                    required
                                />
                            </label>
                            <label>
                                <p>Total Kgs</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="200"
                                    disabled="disabled"
                                    name="e_Total_KG_weight"
                                    value={!isNaN(formInputs['e_Total_KG_weight']) ? formInputs['e_Total_KG_weight'] : 0}
                                    required
                                />
                            </label>
                            <label>
                                <p>Length (cm)</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    step="0.1"
                                    min="1"
                                    max="200"
                                    name="e_dimLength"
                                    value={!isNaN(formInputs['e_dimLength']) ? formInputs['e_dimLength'] : 0}
                                    onChange={(e) => this.onInputChange(e)}
                                    required
                                />
                            </label>
                            <label>
                                <p>Width (cm)</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    step="0.1"
                                    min="1"
                                    max="200"
                                    name="e_dimWidth"
                                    value={!isNaN(formInputs['e_dimWidth']) ? formInputs['e_dimWidth'] : 0}
                                    onChange={(e) => this.onInputChange(e)}
                                    required
                                />
                            </label>
                            <label>
                                <p>Height (cm)</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    step="0.1"
                                    min="1"
                                    max="200"
                                    name="e_dimHeight"
                                    value={!isNaN(formInputs['e_dimHeight']) ? formInputs['e_dimHeight'] : 0}
                                    onChange={(e) => this.onInputChange(e)}
                                    required
                                />
                            </label>
                            <label>
                                <p>Cubic Meter</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    disabled="disabled"
                                    name="e_1_Total_dimCubicMeter"
                                    value={!isNaN(formInputs['e_1_Total_dimCubicMeter']) ? formInputs['e_1_Total_dimCubicMeter'] : 0}
                                    required
                                />
                            </label>
                            <label>
                                <p>Cubic KG</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    disabled="disabled"
                                    name="total_2_cubic_mass_factor_calc"
                                    value={formInputs['total_2_cubic_mass_factor_calc'] ? formInputs['total_2_cubic_mass_factor_calc'] : ''}
                                />
                            </label>
                        </form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {editMode &&
                        <Button color="danger" onClick={() => this.props.deleteBookingLine()}>Delete</Button>
                    }
                    <Button type="submit" form="simple-line-form" color="primary">{editMode ? 'Update' : 'Submit'}</Button>{' '}
                    <Button color="secondary" onClick={() => this.props.toggleModal()}>Cancel</Button>
                </ModalFooter>
            </ReactstrapModal>
        );
    }
}

export default SimpleLineModal;



// WEBPACK FOOTER //
// ./src/components/CommonModals/SimpleLineModal.js